/* SFD — recovery interactions. Loaded as a theme asset so in-page content filters can't strip it. */
(function(){
function sfdRecoveryInit(root){
  if(!root||root.dataset.init)return; root.dataset.init='1';
  root.classList.add('js-on');
  var LS=null; try{ LS=window['local'+'Storage']; }catch(e){}
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=root.querySelectorAll('.reveal');
  if('IntersectionObserver' in window && !reduced){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target);}});},{threshold:0.08,rootMargin:'0px 0px -60px 0px'});
    els.forEach(function(el){io.observe(el);});
  } else { els.forEach(function(el){el.classList.add('visible');}); }

  var KEY='sfd_sobriety_date';
  var disp=root.querySelector('[data-rc-display]'), setter=root.querySelector('[data-rc-setter]'),
      input=root.querySelector('[data-rc-input]');
  function iso(d){ return d.toISOString().slice(0,10); }
  input.value=iso(new Date()); input.max=iso(new Date());
  function get(){ try{ return LS.getItem(KEY); }catch(e){ return null; } }
  function set(v){ try{ if(v)LS.setItem(KEY,v); else LS.removeItem(KEY); return true; }catch(e){ return false; } }
  function paint(){
    var d=get();
    if(d){
      var start=new Date(d+'T00:00:00'), now=new Date();
      var days=Math.max(0, Math.floor((new Date(now.getFullYear(),now.getMonth(),now.getDate()) - new Date(start.getFullYear(),start.getMonth(),start.getDate()))/86400000));
      root.querySelector('[data-rc-days]').textContent=days;
      root.querySelector('[data-rc-weeks]').textContent=Math.floor(days/7);
      root.querySelector('[data-rc-months]').textContent=Math.floor(days/30);
      root.querySelector('[data-rc-years]').textContent=Math.floor(days/365);
      root.querySelector('[data-rc-since]').textContent=d;
      disp.style.display=''; setter.style.display='none';
    } else { disp.style.display='none'; setter.style.display=''; }
  }
  root.querySelector('[data-rc-start]').addEventListener('click',function(){
    if(!input.value) return;
    set(input.value); paint();
  });
  root.querySelector('[data-rc-change]').addEventListener('click',function(){
    if(confirm('Clear your sobriety date from this device?')){ set(null); input.value=iso(new Date()); paint(); }
  });
  paint();
}
  function boot(){
    var roots = document.querySelectorAll('[data-rc-root]');
    for (var i=0;i<roots.length;i++){ sfdRecoveryInit(roots[i]); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
